<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ded">This book is dedicated <br/>to the 13 million Jews and the 1,300 million Muslims in the world<br/>in the hope that they may renew<br/>in the Twenty–First Century<br/>the mutual tolerance, respect and partnership<br/>that marked many periods in their history</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7ae2a068